export class UpdateClientOrganizationRequest {
  assignedSeats: number;
}
